import { useTranslation } from "react-i18next";
import { img } from "../constants/assets";
import BlurRevealText from "./BlurRevealText";
import { useBookDemo } from "../context/BookDemoContext";

function ReadyCheckIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M3.75 10.75 8 15l8.25-10"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ReadyDotIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="10" cy="10" r="3" fill="currentColor" />
    </svg>
  );
}

function ReadyArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10.4688 4.375L16.0938 10L10.4688 15.625M15.3125 10H3.90625"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ReadyToBuild() {
  const { t } = useTranslation();
  const { openBookDemo } = useBookDemo();
  const points = t("readyToBuild.points", { returnObjects: true });

  return (
    <section className="ready-build-section">
      <div className="container">
        <div className="ready-build-panel">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-lg-6">
              <BlurRevealText
                as="h2"
                className="ready-build-title"
                lines={[t("readyToBuild.title1"), t("readyToBuild.title2")]}
              />
              <p className="ready-build-text">{t("readyToBuild.subtitle")}</p>

              <ul className="ready-build-list">
                {points.map((point, index) => (
                  <li className="ready-build-item" key={point}>
                    <span className="ready-build-item-icon" aria-hidden="true">
                      {index === points.length - 1 ? (
                        <ReadyDotIcon />
                      ) : (
                        <ReadyCheckIcon />
                      )}
                    </span>
                    <span className="ready-build-item-label">{point}</span>
                  </li>
                ))}
              </ul>

              <div className="ready-build-actions cta-banner-actions">
                <button
                  className="cta-btn-primary"
                  type="button"
                  onClick={openBookDemo}
                >
                  <span className="cta-btn-label">
                    {t("common.bookTechnicalDemo")}
                  </span>
                  <span className="cta-btn-icon">
                    <ReadyArrowIcon />
                  </span>
                </button>
                <button
                  className="cta-btn-secondary"
                  type="button"
                  onClick={openBookDemo}
                >
                  <span className="cta-btn-label">
                    {t("readyToBuild.talkToArchitect")}
                  </span>
                </button>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="ready-build-visual">
                <img
                  className="ready-build-image"
                  src={img("heroRight.png")}
                  alt={t("readyToBuild.imageAlt")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReadyToBuild;
